import { render, staticRenderFns } from "./FormCheck.vue?vue&type=template&id=3e2c738a&scoped=true&"
import script from "./FormCheck.vue?vue&type=script&lang=js&"
export * from "./FormCheck.vue?vue&type=script&lang=js&"
import style0 from "./FormCheck.vue?vue&type=style&index=0&id=3e2c738a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2c738a",
  null
  
)

export default component.exports